/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_VisibleInputs */

const vi_shop_ocop_visible = /** @type {(inputs: Shop_Ocop_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện huy hiệu`)
};

/**

* @param {Shop_Ocop_VisibleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_visible = /** @type {((inputs?: Shop_Ocop_VisibleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_VisibleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_visible(inputs)
});